import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Context } from "Context/Context";
import QCRLogoMark from "Components/Icons/QCRLogoMark";
import { ADMIN, CLIENT, FIRM, PROFESSIONAL } from "Constants";

// Where "home" is for whoever is looking at the 404.
const homeFor = (u) => {
  if (!u) return { to: "/", label: "Go to home page" };
  if (u.role === CLIENT) return { to: "/client/cases", label: "Go to my cases" };
  if (u.role === PROFESSIONAL || u.role === FIRM) return { to: "/attorney/casesFeed/availableCases", label: "Go to cases" };
  if (u.role === ADMIN) return { to: u.isAdminAssistant ? "/admin/approve" : "/admin/outreach", label: "Go to dashboard" };
  return { to: "/", label: "Go to home page" };
};

const NotFound = () => {
  const navigate = useNavigate();
  const { userDetails } = useContext(Context) || {};
  const home = homeFor(userDetails);

  return (
    <div className="col-span-6 w-full min-h-screen bg-cream flex flex-col font-plexsans">
      <div className="flex-none flex items-center bg-navy px-4 lg:px-8 min-h-[52px] lg:min-h-[62px]">
        <Link to={home.to} className="flex items-center gap-[7px] lg:gap-[9px]">
          <QCRLogoMark size={18} color="#c9a26a" />
          <span className="font-semibold text-[12px] lg:text-[13px] leading-none tracking-[.05em] uppercase text-ivory whitespace-nowrap">Quick Case Review</span>
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-[440px] bg-white border border-navy/[.12] rounded-lg px-6 py-9 lg:px-10 lg:py-11 flex flex-col items-center text-center">
          <span className="font-plexmono font-medium text-[11px] leading-none tracking-[.12em] uppercase text-brass">Error 404</span>
          <h1 className="m-0 mt-3 font-spectral font-normal text-[24px] lg:text-[28px] leading-[1.25] text-navy">We couldn't find that page</h1>
          <p className="m-0 mt-3 text-[13.5px] lg:text-[14px] leading-[1.6] text-navy/[.6]">
            The link may be old or mistyped, or the page may have moved.
          </p>
          <div className="w-full mt-7 flex flex-col-reverse sm:flex-row gap-2.5 sm:justify-center">
            <button type="button" onClick={() => navigate(-1)}
              className="w-full sm:w-auto font-semibold text-[13.5px] leading-none text-navy bg-white border border-navy/[.2] hover:bg-navy/[.04] rounded-md py-3 px-5 cursor-pointer">
              Go back
            </button>
            <Link to={home.to}
              className="w-full sm:w-auto font-semibold text-[13.5px] leading-none text-ivory bg-brass hover:bg-brassDark rounded-md py-3 px-5 text-center no-underline">
              {home.label}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
